import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-4xl mx-auto text-center">
          <span className="text-xs font-medium tracking-widest uppercase text-accent-600 bg-accent-100 px-3 py-1 rounded-full">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4 mb-3">
            {contactData.title}
          </h2>
          <p className="text-lg md:text-xl text-secondary-500 font-medium mb-6">
            {contactData.subtitle}
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto mb-10">
            {contactData.description}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {contactData.methods.map((method, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-lg p-8 border border-background-200/70 flex flex-col items-center gap-3"
              >
                <div className="w-14 h-14 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className={`${method.icon} text-accent-500 text-2xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-700">{method.label}</span>
                <span className="text-base font-bold text-foreground-950">{method.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}